import * as React from 'react';
import { ChangeEventHandler } from 'react';
import { OptionsType } from '../AbstractFilterView';
import { OptionsCollection } from '../OptionsCollection';

export interface DropdownFilterProps<VALUE_TYPE, OPTION_TYPE> {
    onChange: ChangeEventHandler<HTMLSelectElement>
    options: OptionsType<OPTION_TYPE>
    value: VALUE_TYPE | undefined
    className?: string
}

export class FilterSelect<VALUE_TYPE extends string | number, OPTION_TYPE> extends React.PureComponent<DropdownFilterProps<VALUE_TYPE, OPTION_TYPE>> {
    public render() {
        const props = this.props;
        const options = props.options;
        const className = props.className || 'pf-select';

        return <div className={className}>
            <select value={props.value} onChange={props.onChange}>
                <option key="none" value="">&nbsp;</option>
                {this.renderOptions(options)}
            </select>
        </div>;
    }

    private renderOptions(options: OptionsType<OPTION_TYPE>): JSX.Element[] {
        if (options instanceof OptionsCollection) {
            return options.map(o => <option key={o.name} value={o.name}>{o.label}</option>);
        } else {
            return this.renderOptions(OptionsCollection.from(options));
        }
    }
}
